import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import HomePage from './HomePage';
import FeatureDetailPage from './FeatureDetailPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/feature/:featureId" element={<FeatureDetailPage />} />
      </Routes>
    </Router>
  );
}

export default App;